import { cn } from "@/lib/utils";

export interface ReportFooterProps {
  disclaimer?: string | null;
  /** 0-based page index; rendered as `pageIndex + 1` when `totalPages` > 1. */
  pageIndex?: number | null;
  totalPages?: number | null;
  className?: string;
}

/** Report page chrome: optional disclaimer and page numbers. */
export const ReportFooter = ({
  disclaimer,
  pageIndex,
  totalPages,
  className,
}: ReportFooterProps) => {
  const hasDisclaimer = disclaimer != null && disclaimer !== "";
  const hasPageContext =
    typeof pageIndex === "number" &&
    typeof totalPages === "number" &&
    totalPages > 1 &&
    pageIndex >= 0 &&
    pageIndex < totalPages;

  if (!hasDisclaimer && !hasPageContext) {
    return null;
  }

  return (
    <footer
      className={cn(
        "flex w-full items-start justify-between gap-4 border-t border-slate-200 pt-2",
        className,
      )}
    >
      {hasDisclaimer ? (
        <p className="m-0 min-w-0 text-[10px] leading-snug text-muted-foreground">
          {disclaimer}
        </p>
      ) : (
        <span />
      )}
      {hasPageContext ? (
        <p className="m-0 shrink-0 text-[10px] leading-snug text-gray-600">
          Page {pageIndex + 1} of {totalPages}
        </p>
      ) : null}
    </footer>
  );
};
